import { useState } from "react";
import { stories } from "@/mocks/stories";
import { formatCount } from "@/utils/format";

export default function GossipSection() {
  const gossip = stories.filter((s) => s.category === "gossip");
  const [openId, setOpenId] = useState<number | null>(null);

  return (
    <section id="gossip" className="bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-800">
              <i className="ri-chat-smile-line text-primary-500" /> 课间八卦聚集地
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-900 md:text-4xl">
              走廊上的八卦速递
            </h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">
              从图书馆到食堂、从运动会到广播站，校园处处是瓜田。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-foreground-400">
            <i className="ri-loader-4-line animate-spin text-primary-500" /> 速递持续更新中
          </span>
        </div>

        <div className="mt-7 flex flex-col gap-4">
          {gossip.map((s) => {
            const open = openId === s.id;
            return (
              <article
                key={s.id}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
              >
                <button
                  onClick={() => setOpenId(open ? null : s.id)}
                  className="flex w-full items-start gap-3 p-4 text-left md:items-center md:gap-5 md:p-5"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-50 text-2xl">
                    {s.reaction}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-background-200/80 px-2 py-0.5 text-[11px] font-bold text-foreground-600">
                        八卦速递
                      </span>
                      <span className="text-xs text-foreground-400">{s.time}</span>
                    </div>
                    <h3 className="mt-1.5 font-heading text-base leading-snug text-foreground-900 md:text-lg">
                      {s.title}
                    </h3>
                    <p className={`mt-1 text-sm text-foreground-600 ${open ? "" : "hidden md:line-clamp-1"}`}>
                      {s.excerpt}
                    </p>
                  </div>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-foreground-400 transition-transform ${
                      open ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-xl" />
                  </span>
                </button>
                {open && (
                  <div className="border-t border-dashed border-background-200 bg-background-100/50 px-4 py-4 md:px-5">
                    <div className="flex items-center justify-between gap-2 text-xs text-foreground-500">
                      <span>
                        <i className="ri-user-smile-line mr-1" />
                        {s.author}
                      </span>
                      <span>
                        <i className="ri-eye-line mr-1" />
                        {formatCount(s.views)} 围观
                        <i className="ri-chat-3-line mx-2 ml-3" />
                        {formatCount(s.comments)} 讨论
                      </span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-700">{s.content.join("")}</p>
                    <div className="mt-3 flex flex-wrap gap-1.5">
                      {s.tags.map((t) => (
                        <span key={t} className="rounded-md bg-primary-50 px-2 py-0.5 text-xs text-primary-700">
                          #{t}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}